import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderConfirmEmailMobile = (data) => openPopupHelper({ popupName: popupNames.CONFIRM_EMAIL_MOBILE, data });
